module.exports = __webpack_public_path__ + "assets/img/sbac_header_navbar_mobi_arrow.svg?1bd2011a328fcfd467c58a48fa91b816";